/**
 * Copyright 2024 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */
import {useSelector} from 'react-redux';

import {IAppStore} from 'store';

import {phenixWebSiteLinks, documentationLinks} from 'constant-data/links';

import {NewTabLink} from 'components/new-tab-link';

import {useLoginStatus} from 'utility/custom-hooks';

import {
  CopyrightContainer,
  SeparationDot,
  LinksContainer
} from './styles';

const Copyright = (): JSX.Element => {
  const applicationId = useSelector((state: IAppStore) => state.user.applicationId);
  const backendUrlParameter = new URLSearchParams(window.location.search).get('backend');
  const [isLoggedIn] = useLoginStatus(applicationId);
  let privacyPolicyLink;
  let termsOfServiceLink;
  const getFirstSegment = (host: string = window.location.host): string => {
    return host.split('.')[0];
  };

  const getLinkByEnviroment = (host: string): void => {
    if (
      host.startsWith('stg-') ||
      host.endsWith('-stg') ||
      host.includes('-stg-') ||
      host === 'stg'
    ) {
      privacyPolicyLink = phenixWebSiteLinks.privacyPolicyStaging;
      termsOfServiceLink = phenixWebSiteLinks.termsOfServiceStaging;
    } else {
      privacyPolicyLink = phenixWebSiteLinks.privacyPolicyProduction;
      termsOfServiceLink = phenixWebSiteLinks.termsOfServiceProduction;
    }
  };

  const firstHostSegment = getFirstSegment();

  if (firstHostSegment.startsWith('local') || firstHostSegment.endsWith('-local')) {
    if (backendUrlParameter) {
      const {hostname} = new URL(backendUrlParameter);
      const backendFirstSegment = getFirstSegment(hostname);

      getLinkByEnviroment(backendFirstSegment);
    } else {
      getLinkByEnviroment(firstHostSegment);
    }
  } else {
    getLinkByEnviroment(firstHostSegment);
  }

  return (
    <CopyrightContainer isLoggedIn={isLoggedIn}>
      <strong>
        <NewTabLink link={phenixWebSiteLinks.mainWebSite} text={`© ${new Date().getFullYear()} Phenix RTS`}/>
      </strong>
      <LinksContainer>
        <NewTabLink link={privacyPolicyLink} text="Privacy Policy"/>
        <SeparationDot />
        <NewTabLink link={termsOfServiceLink} text="Terms of Service"/>
        <SeparationDot />
        <NewTabLink link={documentationLinks.portal} text="Documentation"/>
      </LinksContainer>
    </CopyrightContainer>
  );
};

export default Copyright;